import React from 'react';
import JsonSchemaInput from './JsonSchemaInput';
import { teacherModelSupportsJsonSchema } from '../utils/supportsJsonSchema';

/**
 * Teacher JSON schema editor. Hidden when the selected commercial model
 * cannot use OpenAI Structured Outputs (``response_format: json_schema``).
 * A saved ``teacher_schema`` is left in parent state so switching back
 * to gpt-4o restores it.
 */
const TeacherJsonSchemaField = ({
    provider,
    modelId,
    availableProviders,
    ...inputProps
}) => {
    if (!teacherModelSupportsJsonSchema({
        provider,
        modelId,
        availableProviders,
    })) {
        return null;
    }
    return <JsonSchemaInput {...inputProps} />;
};

export default TeacherJsonSchemaField;
